import { mapGetters, mapActions } from 'vuex';
import dotdotdotIcon from '@/components/pinning/pin-settings/dotdotdot-icon';
import {
  SORT_TYPE_OPTIONS,
  SORT_PARAMETER_OPTIONS,
  DEFAULT_SORT_PARAMETER,
  normalizePortfolioSort,
} from '@/components/pinning/pinboard-portfolio-sort';
import PINBOARD_REGISTRY from '@/components/pinning/pinboard-registry';
import menuBus from '@/utils/menu-bus';

const REGISTRY_MAP = {};
PINBOARD_REGISTRY.forEach((group) => {
  group.widgets.forEach((w) => {
    REGISTRY_MAP[w.name] = w;
  });
});

const SORT_OPTIONS = [
  { value: 'biggest-change', label: 'Biggest change' },
  { value: 'investment-size', label: 'Investment size' },
  { value: 'trade-volume', label: 'Trade volume' },
];

const ITEMS_PER_PAGE_OPTIONS = [5, 10, 25];

export default {
  components: { dotdotdotIcon },
  props: {
    section: {
      type: Object,
      required: true,
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
      sortOptions: SORT_OPTIONS,
      itemsPerPageOptions: ITEMS_PER_PAGE_OPTIONS,
    };
  },
  created() {
    this.instanceId = Symbol('pinboard-widget-settings-menu');
    this.menuOpenedHandler = (uid) => {
      if (uid !== this.instanceId) {
        this.showMenu = false;
      }
    };
    menuBus.on('widget-menu-opened', this.menuOpenedHandler);
  },
  beforeUnmount() {
    menuBus.off('widget-menu-opened', this.menuOpenedHandler);
  },
  computed: {
    ...mapGetters('pinning', ['getWidgetSort', 'getWidgetShowPositions', 'getWidgetItemsPerPage']),
    showSortBy() {
      const entry = REGISTRY_MAP[this.section.name];
      return entry && entry.sortable !== false;
    },
    sortValue() {
      return this.getWidgetSort(this.section.name);
    },
    isPortfolio() {
      return this.section.name === 'portfolio';
    },
    portfolioSortValue() {
      return normalizePortfolioSort(this.getWidgetSort('portfolio'));
    },
    portfolioSortTypeOptions() {
      return SORT_TYPE_OPTIONS;
    },
    portfolioSortParameterOptions() {
      return SORT_PARAMETER_OPTIONS[this.portfolioSortValue.sort] || [];
    },
    showPositions() {
      return this.getWidgetShowPositions('portfolio');
    },
    itemsPerPage() {
      return this.getWidgetItemsPerPage('portfolio');
    },
  },
  methods: {
    ...mapActions('pinning', ['setWidgetSort', 'setWidgetShowPositions', 'setWidgetItemsPerPage']),
    onSortChange(val) {
      this.setWidgetSort({ widget: this.section.name, sort: val });
      this.showMenu = false;
    },
    onPortfolioSortTypeChange(val) {
      const sortParameter = DEFAULT_SORT_PARAMETER[val] || '';
      this.setWidgetSort({ widget: 'portfolio', sort: { sort: val, sortParameter } });
      this.showMenu = false;
    },
    onPortfolioSortParameterChange(val) {
      this.setWidgetSort({
        widget: 'portfolio',
        sort: { sort: this.portfolioSortValue.sort, sortParameter: val },
      });
      this.showMenu = false;
    },
    onShowPositionsChange(checked) {
      this.setWidgetShowPositions({ widget: 'portfolio', showPositions: checked });
    },
    onItemsPerPageChange(val) {
      this.setWidgetItemsPerPage({ widget: 'portfolio', itemsPerPage: val });
      this.showMenu = false;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
      if (this.showMenu) {
        menuBus.emit('widget-menu-opened', this.instanceId);
      }
    },
    onMoveUp() {
      this.$emit('move-up');
    },
    onMoveDown() {
      this.$emit('move-down');
    },
  },
};
